module.exports = __webpack_public_path__ + "img/people-blue-icon.6f149998.png";